(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  root.classList.add('cmp-js');

  var items = document.querySelectorAll('.multicolumn-list__item');
  items.forEach(function (el, i) { el.style.setProperty('--cmp-d', (i * 120) + 'ms'); });
  function showAll() { items.forEach(function (el) { el.classList.add('cmp-in'); }); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cmp-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
    setTimeout(showAll, 4000);
  } else { showAll(); }

  var bar = document.createElement('div');
  bar.className = 'cmp-progress';
  document.body.appendChild(bar);

  var slideshow = document.querySelector('.slideshow');
  var ticking = false;
  function update() {
    ticking = false;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
    if (slideshow) {
      var r = slideshow.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        root.style.setProperty('--cmp-py', (p * -40).toFixed(1) + 'px');
      }
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
